import successCircle from "../../../assets/svg/implicit_temperature_success.svg";
import failCircle from "../../../assets/svg/implicit_temperature_fail.svg";
import partialCircle from "../../../assets/svg/partial_circle.svg";
import naCircle from "../../../assets/svg/na_circle.svg";
import greenCheckbox from "../../../assets/svg/green_check_box.svg";
import redCheckbox from "../../../assets/svg/red_cross_box.svg";
import partialCheckbox from "../../../assets/svg/partial_checkbox.svg";
import naCheckbox from "../../../assets/svg/na_checkbox.svg";
import { statusBadgeColors } from "../../../styles";

export enum CA100_disclosureMetrics {
  Indicator_1 = "Indicator_1",
  Indicator_1_Progress = "Indicator_1_Progress",
  Metric_1_1_a = "Metric_1_1_a",
  Metric_1_1_a_Progress = "Metric_1_1_a_Progress",
  Metric_1_1_b = "Metric_1_1_b",
  Metric_1_1_b_Progress = "Metric_1_1_b_Progress",
  Indicator_2 = "Indicator_2",
  Indicator_2_Progress = "Indicator_2_Progress",
  Indicator_2_1 = "Indicator_2_1",
  Indicator_2_1_Progress = "Indicator_2_1_Progress",
  Indicator_2_2 = "Indicator_2_2",
  Indicator_2_2_Progress = "Indicator_2_2_Progress",
  Metric_2_2_a = "Metric_2_2_a",
  Metric_2_2_a_Progress = "Metric_2_2_a_Progress",
  Metric_2_2_b = "Metric_2_2_b",
  Metric_2_2_b_Progress = "Metric_2_2_b_Progress",
  Indicator_2_3 = "Indicator_2_3",
  Indicator_2_3_Progress = "Indicator_2_3_Progress",
  Indicator_3 = "Indicator_3",
  Indicator_3_Progress = "Indicator_3_Progress",
  Indicator_3_1 = "Indicator_3_1",
  Indicator_3_1_Progress = "Indicator_3_1_Progress",
  Indicator_3_2 = "Indicator_3_2",
  Indicator_3_2_Progress = "Indicator_3_2_Progress",
  Metric_3_2_a = "Metric_3_2_a",
  Metric_3_2_a_Progress = "Metric_3_2_a_Progress",
  Metric_3_2_b = "Metric_3_2_b",
  Metric_3_2_b_Progress = "Metric_3_2_b_Progress",
  Indicator_3_3 = "Indicator_3_3",
  Indicator_3_3_Progress = "Indicator_3_3_Progress",
  Indicator_3_4 = "Indicator_3_4",
  Indicator_3_4_Progress = "Indicator_3_4_Progress",
  Indicator_4 = "Indicator_4",
  Indicator_4_Progress = "Indicator_4_Progress",
  Indicator_4_1 = "Indicator_4_1",
  Indicator_4_1_Progress = "Indicator_4_1_Progress",
  Indicator_4_2 = "Indicator_4_2",
  Indicator_4_2_Progress = "Indicator_4_2_Progress",
  Metric_4_2_a = "Metric_4_2_a",
  Metric_4_2_a_Progress = "Metric_4_2_a_Progress",
  Metric_4_2_b = "Metric_4_2_b",
  Metric_4_2_b_Progress = "Metric_4_2_b_Progress",
  Indicator_4_3 = "Indicator_4_3",
  Indicator_4_3_Progress = "Indicator_4_3_Progress",
  Indicator_5 = "Indicator_5",
  Indicator_5_Progress = "Indicator_5_Progress",
  Indicator_5_1 = "Indicator_5_1",
  Indicator_5_1_Progress = "Indicator_5_1_Progress",
  Metric_5_1_a = "Metric_5_1_a",
  Metric_5_1_a_Progress = "Metric_5_1_a_Progress",
  Metric_5_1_b = "Metric_5_1_b",
  Metric_5_1_b_Progress = "Metric_5_1_b_Progress",
  Metric_5_1_c = "Metric_5_1_c",
  Metric_5_1_c_Progress = "Metric_5_1_c_Progress",
  Metric_5_1_d = "Metric_5_1_d",
  Metric_5_1_d_Progress = "Metric_5_1_d_Progress",
  Indicator_5_2 = "Indicator_5_2",
  Indicator_5_2_Progress = "Indicator_5_2_Progress",
  Metric_5_2_a = "Metric_5_2_a",
  Metric_5_2_a_Progress = "Metric_5_2_a_Progress",
  Metric_5_2_b = "Metric_5_2_b",
  Metric_5_2_b_Progress = "Metric_5_2_b_Progress",
  Indicator_6 = "Indicator_6",
  Indicator_6_Progress = "Indicator_6_Progress",
  Indicator_6_1 = "Indicator_6_1",
  Indicator_6_1_Progress = "Indicator_6_1_Progress",
  Metric_6_1_a = "Metric_6_1_a",
  Metric_6_1_a_Progress = "Metric_6_1_a_Progress",
  Metric_6_1_b = "Metric_6_1_b",
  Metric_6_1_b_Progress = "Metric_6_1_b_Progress",
  Indicator_6_2 = "Indicator_6_2",
  Indicator_6_2_Progress = "Indicator_6_2_Progress",
  Metric_6_2_a = "Metric_6_2_a",
  Metric_6_2_a_Progress = "Metric_6_2_a_Progress",
  Metric_6_2_b = "Metric_6_2_b",
  Metric_6_2_b_Progress = "Metric_6_2_b_Progress",
  Indicator_7 = "Indicator_7",
  Indicator_7_Progress = "Indicator_7_Progress",
  Indicator_7_1 = "Indicator_7_1",
  Indicator_7_1_Progress = "Indicator_7_1_Progress",
  Metric_7_1_a = "Metric_7_1_a",
  Metric_7_1_a_Progress = "Metric_7_1_a_Progress",
  Metric_7_1_b = "Metric_7_1_b",
  Metric_7_1_b_Progress = "Metric_7_1_b_Progress",
  Metric_7_1_c = "Metric_7_1_c",
  Metric_7_1_c_Progress = "Metric_7_1_c_Progress",
  Indicator_7_2 = "Indicator_7_2",
  Indicator_7_2_Progress = "Indicator_7_2_Progress",
  Metric_7_2_a = "Metric_7_2_a",
  Metric_7_2_a_Progress = "Metric_7_2_a_Progress",
  Metric_7_2_b = "Metric_7_2_b",
  Metric_7_2_b_Progress = "Metric_7_2_b_Progress",
  Indicator_8 = "Indicator_8",
  Indicator_8_Progress = "Indicator_8_Progress",
  Indicator_8_1 = "Indicator_8_1",
  Indicator_8_1_Progress = "Indicator_8_1_Progress",
  Metric_8_1_a = "Metric_8_1_a",
  Metric_8_1_a_Progress = "Metric_8_1_a_Progress",
  Metric_8_1_b = "Metric_8_1_b",
  Metric_8_1_b_Progress = "Metric_8_1_b_Progress",
  Indicator_8_2 = "Indicator_8_2",
  Indicator_8_2_Progress = "Indicator_8_2_Progress",
  Metric_8_2_a = "Metric_8_2_a",
  Metric_8_2_a_Progress = "Metric_8_2_a_Progress",
  Metric_8_2_b = "Metric_8_2_b",
  Metric_8_2_b_Progress = "Metric_8_2_b_Progress",
  Indicator_8_3 = "Indicator_8_3",
  Indicator_8_3_Progress = "Indicator_8_3_Progress",
  Metric_8_3_a = "Metric_8_3_a",
  Metric_8_3_a_Progress = "Metric_8_3_a_Progress",
  Metric_8_3_b = "Metric_8_3_b",
  Metric_8_3_b_Progress = "Metric_8_3_b_Progress",
  Indicator_9 = "Indicator_9",
  Indicator_9_Progress = "Indicator_9_Progress",
  Indicator_9_1 = "Indicator_9_1",
  Indicator_9_1_Progress = "Indicator_9_1_Progress",
  Metric_9_1_a = "Metric_9_1_a",
  Metric_9_1_a_Progress = "Metric_9_1_a_Progress",
  Metric_9_1_b = "Metric_9_1_b",
  Metric_9_1_b_Progress = "Metric_9_1_b_Progress",
  Metric_9_1_c = "Metric_9_1_c",
  Metric_9_1_c_Progress = "Metric_9_1_c_Progress",
  Indicator_9_2 = "Indicator_9_2",
  Indicator_9_2_Progress = "Indicator_9_2_Progress",
  Metric_9_2_a = "Metric_9_2_a",
  Metric_9_2_a_Progress = "Metric_9_2_a_Progress",
  Metric_9_2_b = "Metric_9_2_b",
  Metric_9_2_b_Progress = "Metric_9_2_b_Progress",
  Metric_9_2_c = "Metric_9_2_c",
  Metric_9_2_c_Progress = "Metric_9_2_c_Progress",
  Indicator_10 = "Indicator_10",
  Indicator_10_Progress = "Indicator_10_Progress",
  Indicator_10_1 = "Indicator_10_1",
  Indicator_10_1_Progress = "Indicator_10_1_Progress",
  Metric_10_1_a = "Metric_10_1_a",
  Metric_10_1_a_Progress = "Metric_10_1_a_Progress",
  Metric_10_1_b = "Metric_10_1_b",
  Metric_10_1_b_Progress = "Metric_10_1_b_Progress",
  Indicator_10_2 = "Indicator_10_2",
  Indicator_10_2_Progress = "Indicator_10_2_Progress",
  Metric_10_2_a = "Metric_10_2_a",
  Metric_10_2_a_Progress = "Metric_10_2_a_Progress",
  Metric_10_2_b = "Metric_10_2_b",
  Metric_10_2_b_Progress = "Metric_10_2_b_Progress",
  Indicator_11 = "Indicator_11",
  Indicator_11_Progress = "Indicator_11_Progress",
  Indicator_11_1 = "Indicator_11_1",
  Indicator_11_1_Progress = "Indicator_11_1_Progress",
  Metric_11_1_a = "Metric_11_1_a",
  Metric_11_1_a_Progress = "Metric_11_1_a_Progress",
  Metric_11_1_b = "Metric_11_1_b",
  Metric_11_1_b_Progress = "Metric_11_1_b_Progress",
  Metric_11_1_c = "Metric_11_1_c",
  Metric_11_1_c_Progress = "Metric_11_1_c_Progress",
  Indicator_11_2 = "Indicator_11_2",
  Indicator_11_2_Progress = "Indicator_11_2_Progress",
  Metric_11_2_a = "Metric_11_2_a",
  Metric_11_2_a_Progress = "Metric_11_2_a_Progress",
  Metric_11_2_b = "Metric_11_2_b",
  Metric_11_2_b_Progress = "Metric_11_2_b_Progress",
  Indicator_11_3 = "Indicator_11_3",
  Indicator_11_3_Progress = "Indicator_11_3_Progress",
  Metric_11_3_a = "Metric_11_3_a",
  Metric_11_3_a_Progress = "Metric_11_3_a_Progress",
  Metric_11_3_b = "Metric_11_3_b",
  Metric_11_3_b_Progress = "Metric_11_3_b_Progress",
  Metric_11_3_c = "Metric_11_3_c",
  Metric_11_3_c_Progress = "Metric_11_3_c_Progress",
}
export enum CA100_lobbyingMetrics {
  Indicator_1 = "Lobbying_Indicator_1",
  Indicator_1_Progress = "Lobbying_Indicator_1_Progress",
  Indicator_1_1 = "Lobbying_Indicator_1_1",
  Indicator_1_1_Progress = "Lobbying_Indicator_1_1_Progress",
  Indicator_1_2 = "Lobbying_Indicator_1_2",
  Indicator_1_2_Progress = "Lobbying_Indicator_1_2_Progress",
  Indicator_2 = "Lobbying_Indicator_2",
  Indicator_2_Progress = "Lobbying_Indicator_2_Progress",
  Indicator_2_1 = "Lobbying_Indicator_2_1",
  Indicator_2_1_Progress = "Lobbying_Indicator_2_1_Progress",
  Indicator_2_2 = "Lobbying_Indicator_2_2",
  Indicator_2_2_Progress = "Lobbying_Indicator_2_2_Progress",
  Indicator_3 = "Lobbying_Indicator_3",
  Indicator_3_Progress = "Lobbying_Indicator_3_Progress",
}

export type FormattedCA100Metric<
  T extends CA100_disclosureMetrics | CA100_lobbyingMetrics
> = {
  value: string;
  metricId: T;
  metricName: string;
  metricDescription: string;
};

export const CA100_disclosureMetricLevels: Record<
  CA100_disclosureMetrics,
  number
> = {
  // Indicator 1 (special case):
  [CA100_disclosureMetrics.Indicator_1]: 1,
  [CA100_disclosureMetrics.Indicator_1_Progress]: 1,
  [CA100_disclosureMetrics.Metric_1_1_a]: 2,
  [CA100_disclosureMetrics.Metric_1_1_a_Progress]: 2,
  [CA100_disclosureMetrics.Metric_1_1_b]: 2,
  [CA100_disclosureMetrics.Metric_1_1_b_Progress]: 2,

  // Indicator 2 + sub‐indicators and metrics:
  [CA100_disclosureMetrics.Indicator_2]: 1,
  [CA100_disclosureMetrics.Indicator_2_Progress]: 1,
  [CA100_disclosureMetrics.Indicator_2_1]: 2,
  [CA100_disclosureMetrics.Indicator_2_1_Progress]: 2,
  [CA100_disclosureMetrics.Indicator_2_2]: 2,
  [CA100_disclosureMetrics.Indicator_2_2_Progress]: 2,
  [CA100_disclosureMetrics.Metric_2_2_a]: 3,
  [CA100_disclosureMetrics.Metric_2_2_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_2_2_b]: 3,
  [CA100_disclosureMetrics.Metric_2_2_b_Progress]: 3,
  [CA100_disclosureMetrics.Indicator_2_3]: 2,
  [CA100_disclosureMetrics.Indicator_2_3_Progress]: 2,

  // Indicator 3 + sub‐indicators and metrics:
  [CA100_disclosureMetrics.Indicator_3]: 1,
  [CA100_disclosureMetrics.Indicator_3_Progress]: 1,
  [CA100_disclosureMetrics.Indicator_3_1]: 2,
  [CA100_disclosureMetrics.Indicator_3_1_Progress]: 2,
  [CA100_disclosureMetrics.Indicator_3_2]: 2,
  [CA100_disclosureMetrics.Indicator_3_2_Progress]: 2,
  [CA100_disclosureMetrics.Metric_3_2_a]: 3,
  [CA100_disclosureMetrics.Metric_3_2_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_3_2_b]: 3,
  [CA100_disclosureMetrics.Metric_3_2_b_Progress]: 3,
  [CA100_disclosureMetrics.Indicator_3_3]: 2,
  [CA100_disclosureMetrics.Indicator_3_3_Progress]: 2,
  [CA100_disclosureMetrics.Indicator_3_4]: 2,
  [CA100_disclosureMetrics.Indicator_3_4_Progress]: 2,

  // Indicator 4 + sub‐indicators and metrics:
  [CA100_disclosureMetrics.Indicator_4]: 1,
  [CA100_disclosureMetrics.Indicator_4_Progress]: 1,
  [CA100_disclosureMetrics.Indicator_4_1]: 2,
  [CA100_disclosureMetrics.Indicator_4_1_Progress]: 2,
  [CA100_disclosureMetrics.Indicator_4_2]: 2,
  [CA100_disclosureMetrics.Indicator_4_2_Progress]: 2,
  [CA100_disclosureMetrics.Metric_4_2_a]: 3,
  [CA100_disclosureMetrics.Metric_4_2_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_4_2_b]: 3,
  [CA100_disclosureMetrics.Metric_4_2_b_Progress]: 3,
  [CA100_disclosureMetrics.Indicator_4_3]: 2,
  [CA100_disclosureMetrics.Indicator_4_3_Progress]: 2,

  // Indicator 5 + sub‐indicators and metrics:
  [CA100_disclosureMetrics.Indicator_5]: 1,
  [CA100_disclosureMetrics.Indicator_5_Progress]: 1,
  [CA100_disclosureMetrics.Indicator_5_1]: 2,
  [CA100_disclosureMetrics.Indicator_5_1_Progress]: 2,
  [CA100_disclosureMetrics.Metric_5_1_a]: 3,
  [CA100_disclosureMetrics.Metric_5_1_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_5_1_b]: 3,
  [CA100_disclosureMetrics.Metric_5_1_b_Progress]: 3,
  [CA100_disclosureMetrics.Metric_5_1_c]: 3,
  [CA100_disclosureMetrics.Metric_5_1_c_Progress]: 3,
  [CA100_disclosureMetrics.Metric_5_1_d]: 3,
  [CA100_disclosureMetrics.Metric_5_1_d_Progress]: 3,
  [CA100_disclosureMetrics.Indicator_5_2]: 2,
  [CA100_disclosureMetrics.Indicator_5_2_Progress]: 2,
  [CA100_disclosureMetrics.Metric_5_2_a]: 3,
  [CA100_disclosureMetrics.Metric_5_2_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_5_2_b]: 3,
  [CA100_disclosureMetrics.Metric_5_2_b_Progress]: 3,

  // Indicator 6 + sub‐indicators and metrics:
  [CA100_disclosureMetrics.Indicator_6]: 1,
  [CA100_disclosureMetrics.Indicator_6_Progress]: 1,
  [CA100_disclosureMetrics.Indicator_6_1]: 2,
  [CA100_disclosureMetrics.Indicator_6_1_Progress]: 2,
  [CA100_disclosureMetrics.Metric_6_1_a]: 3,
  [CA100_disclosureMetrics.Metric_6_1_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_6_1_b]: 3,
  [CA100_disclosureMetrics.Metric_6_1_b_Progress]: 3,
  [CA100_disclosureMetrics.Indicator_6_2]: 2,
  [CA100_disclosureMetrics.Indicator_6_2_Progress]: 2,
  [CA100_disclosureMetrics.Metric_6_2_a]: 3,
  [CA100_disclosureMetrics.Metric_6_2_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_6_2_b]: 3,
  [CA100_disclosureMetrics.Metric_6_2_b_Progress]: 3,

  // Indicator 7 + sub‐indicators and metrics:
  [CA100_disclosureMetrics.Indicator_7]: 1,
  [CA100_disclosureMetrics.Indicator_7_Progress]: 1,
  [CA100_disclosureMetrics.Indicator_7_1]: 2,
  [CA100_disclosureMetrics.Indicator_7_1_Progress]: 2,
  [CA100_disclosureMetrics.Metric_7_1_a]: 3,
  [CA100_disclosureMetrics.Metric_7_1_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_7_1_b]: 3,
  [CA100_disclosureMetrics.Metric_7_1_b_Progress]: 3,
  [CA100_disclosureMetrics.Metric_7_1_c]: 3,
  [CA100_disclosureMetrics.Metric_7_1_c_Progress]: 3,
  [CA100_disclosureMetrics.Indicator_7_2]: 2,
  [CA100_disclosureMetrics.Indicator_7_2_Progress]: 2,
  [CA100_disclosureMetrics.Metric_7_2_a]: 3,
  [CA100_disclosureMetrics.Metric_7_2_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_7_2_b]: 3,
  [CA100_disclosureMetrics.Metric_7_2_b_Progress]: 3,

  // Indicator 8 + sub‐indicators and metrics:
  [CA100_disclosureMetrics.Indicator_8]: 1,
  [CA100_disclosureMetrics.Indicator_8_Progress]: 1,
  [CA100_disclosureMetrics.Indicator_8_1]: 2,
  [CA100_disclosureMetrics.Indicator_8_1_Progress]: 2,
  [CA100_disclosureMetrics.Metric_8_1_a]: 3,
  [CA100_disclosureMetrics.Metric_8_1_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_8_1_b]: 3,
  [CA100_disclosureMetrics.Metric_8_1_b_Progress]: 3,
  [CA100_disclosureMetrics.Indicator_8_2]: 2,
  [CA100_disclosureMetrics.Indicator_8_2_Progress]: 2,
  [CA100_disclosureMetrics.Metric_8_2_a]: 3,
  [CA100_disclosureMetrics.Metric_8_2_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_8_2_b]: 3,
  [CA100_disclosureMetrics.Metric_8_2_b_Progress]: 3,
  [CA100_disclosureMetrics.Indicator_8_3]: 2,
  [CA100_disclosureMetrics.Indicator_8_3_Progress]: 2,
  [CA100_disclosureMetrics.Metric_8_3_a]: 3,
  [CA100_disclosureMetrics.Metric_8_3_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_8_3_b]: 3,
  [CA100_disclosureMetrics.Metric_8_3_b_Progress]: 3,

  // Indicator 9 + sub‐indicators and metrics:
  [CA100_disclosureMetrics.Indicator_9]: 1,
  [CA100_disclosureMetrics.Indicator_9_Progress]: 1,
  [CA100_disclosureMetrics.Indicator_9_1]: 2,
  [CA100_disclosureMetrics.Indicator_9_1_Progress]: 2,
  [CA100_disclosureMetrics.Metric_9_1_a]: 3,
  [CA100_disclosureMetrics.Metric_9_1_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_9_1_b]: 3,
  [CA100_disclosureMetrics.Metric_9_1_b_Progress]: 3,
  [CA100_disclosureMetrics.Metric_9_1_c]: 3,
  [CA100_disclosureMetrics.Metric_9_1_c_Progress]: 3,
  [CA100_disclosureMetrics.Indicator_9_2]: 2,
  [CA100_disclosureMetrics.Indicator_9_2_Progress]: 2,
  [CA100_disclosureMetrics.Metric_9_2_a]: 3,
  [CA100_disclosureMetrics.Metric_9_2_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_9_2_b]: 3,
  [CA100_disclosureMetrics.Metric_9_2_b_Progress]: 3,
  [CA100_disclosureMetrics.Metric_9_2_c]: 3,
  [CA100_disclosureMetrics.Metric_9_2_c_Progress]: 3,

  // Indicator 10 + sub‐indicators and metrics:
  [CA100_disclosureMetrics.Indicator_10]: 1,
  [CA100_disclosureMetrics.Indicator_10_Progress]: 1,
  [CA100_disclosureMetrics.Indicator_10_1]: 2,
  [CA100_disclosureMetrics.Indicator_10_1_Progress]: 2,
  [CA100_disclosureMetrics.Metric_10_1_a]: 3,
  [CA100_disclosureMetrics.Metric_10_1_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_10_1_b]: 3,
  [CA100_disclosureMetrics.Metric_10_1_b_Progress]: 3,
  [CA100_disclosureMetrics.Indicator_10_2]: 2,
  [CA100_disclosureMetrics.Indicator_10_2_Progress]: 2,
  [CA100_disclosureMetrics.Metric_10_2_a]: 3,
  [CA100_disclosureMetrics.Metric_10_2_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_10_2_b]: 3,
  [CA100_disclosureMetrics.Metric_10_2_b_Progress]: 3,

  // Indicator 11 + sub‐indicators and metrics:
  [CA100_disclosureMetrics.Indicator_11]: 1,
  [CA100_disclosureMetrics.Indicator_11_Progress]: 1,
  [CA100_disclosureMetrics.Indicator_11_1]: 2,
  [CA100_disclosureMetrics.Indicator_11_1_Progress]: 2,
  [CA100_disclosureMetrics.Metric_11_1_a]: 3,
  [CA100_disclosureMetrics.Metric_11_1_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_11_1_b]: 3,
  [CA100_disclosureMetrics.Metric_11_1_b_Progress]: 3,
  [CA100_disclosureMetrics.Metric_11_1_c]: 3,
  [CA100_disclosureMetrics.Metric_11_1_c_Progress]: 3,
  [CA100_disclosureMetrics.Indicator_11_2]: 2,
  [CA100_disclosureMetrics.Indicator_11_2_Progress]: 2,
  [CA100_disclosureMetrics.Metric_11_2_a]: 3,
  [CA100_disclosureMetrics.Metric_11_2_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_11_2_b]: 3,
  [CA100_disclosureMetrics.Metric_11_2_b_Progress]: 3,
  [CA100_disclosureMetrics.Indicator_11_3]: 2,
  [CA100_disclosureMetrics.Indicator_11_3_Progress]: 2,
  [CA100_disclosureMetrics.Metric_11_3_a]: 3,
  [CA100_disclosureMetrics.Metric_11_3_a_Progress]: 3,
  [CA100_disclosureMetrics.Metric_11_3_b]: 3,
  [CA100_disclosureMetrics.Metric_11_3_b_Progress]: 3,
  [CA100_disclosureMetrics.Metric_11_3_c]: 3,
  [CA100_disclosureMetrics.Metric_11_3_c_Progress]: 3,
};

export const DISCLOSURE_PROGRESS_METRIC_STUFFIX = "_Progress";

export interface DisclosureTreeNode {
  /** The metric or indicator enum value (e.g. Indicator_2, Metric_6_1_a, etc.) */
  id: CA100_disclosureMetrics;

  /** The corresponding progress metric (e.g. Indicator_2_Progress) if any */
  progress?: CA100_disclosureMetrics;

  /** Nested children (sub‐indicators or metrics).  If empty, this node is a leaf. */
  children?: DisclosureTreeNode[];
}

export interface LobbyingTreeNode {
  /** The metric or indicator enum value (e.g. Indicator_2, Metric_6_1_a, etc.) */
  id: CA100_lobbyingMetrics;

  /** The corresponding progress metric (e.g. Indicator_2_Progress) if any */
  progress?: CA100_lobbyingMetrics;

  /** Nested children (sub‐indicators or metrics).  If empty, this node is a leaf. */
  children?: LobbyingTreeNode[];
}

// Fully nested version of the CA100 structure:
export const CA100_DISCLOSURE_TREE: DisclosureTreeNode[] = [
  // ──────────────────────────────────────────────────────
  // INDICATOR 1 (Special case: directly has metric children)
  // ──────────────────────────────────────────────────────
  {
    id: CA100_disclosureMetrics.Indicator_1,
    progress: CA100_disclosureMetrics.Indicator_1_Progress,
    children: [
      {
        id: CA100_disclosureMetrics.Metric_1_1_a,
        progress: CA100_disclosureMetrics.Metric_1_1_a_Progress,
      },
      {
        id: CA100_disclosureMetrics.Metric_1_1_b,
        progress: CA100_disclosureMetrics.Metric_1_1_b_Progress,
      },
    ],
  },

  // ──────────────────────────────────────────────────────
  // INDICATOR 2
  // ──────────────────────────────────────────────────────
  {
    id: CA100_disclosureMetrics.Indicator_2,
    progress: CA100_disclosureMetrics.Indicator_2_Progress,
    children: [
      {
        id: CA100_disclosureMetrics.Indicator_2_1,
        progress: CA100_disclosureMetrics.Indicator_2_1_Progress,
      },
      {
        id: CA100_disclosureMetrics.Indicator_2_2,
        progress: CA100_disclosureMetrics.Indicator_2_2_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_2_2_a,
            progress: CA100_disclosureMetrics.Metric_2_2_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_2_2_b,
            progress: CA100_disclosureMetrics.Metric_2_2_b_Progress,
          },
        ],
      },
      {
        id: CA100_disclosureMetrics.Indicator_2_3,
        progress: CA100_disclosureMetrics.Indicator_2_3_Progress,
      },
    ],
  },

  // ──────────────────────────────────────────────────────
  // INDICATOR 3
  // ──────────────────────────────────────────────────────
  {
    id: CA100_disclosureMetrics.Indicator_3,
    progress: CA100_disclosureMetrics.Indicator_3_Progress,
    children: [
      {
        id: CA100_disclosureMetrics.Indicator_3_1,
        progress: CA100_disclosureMetrics.Indicator_3_1_Progress,
      },
      {
        id: CA100_disclosureMetrics.Indicator_3_2,
        progress: CA100_disclosureMetrics.Indicator_3_2_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_3_2_a,
            progress: CA100_disclosureMetrics.Metric_3_2_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_3_2_b,
            progress: CA100_disclosureMetrics.Metric_3_2_b_Progress,
          },
        ],
      },
      {
        id: CA100_disclosureMetrics.Indicator_3_3,
        progress: CA100_disclosureMetrics.Indicator_3_3_Progress,
      },
      {
        id: CA100_disclosureMetrics.Indicator_3_4,
        progress: CA100_disclosureMetrics.Indicator_3_4_Progress,
      },
    ],
  },

  // ──────────────────────────────────────────────────────
  // INDICATOR 4
  // ──────────────────────────────────────────────────────
  {
    id: CA100_disclosureMetrics.Indicator_4,
    progress: CA100_disclosureMetrics.Indicator_4_Progress,
    children: [
      {
        id: CA100_disclosureMetrics.Indicator_4_1,
        progress: CA100_disclosureMetrics.Indicator_4_1_Progress,
      },
      {
        id: CA100_disclosureMetrics.Indicator_4_2,
        progress: CA100_disclosureMetrics.Indicator_4_2_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_4_2_a,
            progress: CA100_disclosureMetrics.Metric_4_2_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_4_2_b,
            progress: CA100_disclosureMetrics.Metric_4_2_b_Progress,
          },
        ],
      },
      {
        id: CA100_disclosureMetrics.Indicator_4_3,
        progress: CA100_disclosureMetrics.Indicator_4_3_Progress,
      },
    ],
  },

  // ──────────────────────────────────────────────────────
  // INDICATOR 5
  // ──────────────────────────────────────────────────────
  {
    id: CA100_disclosureMetrics.Indicator_5,
    progress: CA100_disclosureMetrics.Indicator_5_Progress,
    children: [
      {
        id: CA100_disclosureMetrics.Indicator_5_1,
        progress: CA100_disclosureMetrics.Indicator_5_1_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_5_1_a,
            progress: CA100_disclosureMetrics.Metric_5_1_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_5_1_b,
            progress: CA100_disclosureMetrics.Metric_5_1_b_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_5_1_c,
            progress: CA100_disclosureMetrics.Metric_5_1_c_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_5_1_d,
            progress: CA100_disclosureMetrics.Metric_5_1_d_Progress,
          },
        ],
      },
      {
        id: CA100_disclosureMetrics.Indicator_5_2,
        progress: CA100_disclosureMetrics.Indicator_5_2_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_5_2_a,
            progress: CA100_disclosureMetrics.Metric_5_2_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_5_2_b,
            progress: CA100_disclosureMetrics.Metric_5_2_b_Progress,
          },
        ],
      },
    ],
  },

  // ──────────────────────────────────────────────────────
  // INDICATOR 6
  // ──────────────────────────────────────────────────────
  {
    id: CA100_disclosureMetrics.Indicator_6,
    progress: CA100_disclosureMetrics.Indicator_6_Progress,
    children: [
      {
        id: CA100_disclosureMetrics.Indicator_6_1,
        progress: CA100_disclosureMetrics.Indicator_6_1_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_6_1_a,
            progress: CA100_disclosureMetrics.Metric_6_1_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_6_1_b,
            progress: CA100_disclosureMetrics.Metric_6_1_b_Progress,
          },
        ],
      },
      {
        id: CA100_disclosureMetrics.Indicator_6_2,
        progress: CA100_disclosureMetrics.Indicator_6_2_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_6_2_a,
            progress: CA100_disclosureMetrics.Metric_6_2_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_6_2_b,
            progress: CA100_disclosureMetrics.Metric_6_2_b_Progress,
          },
        ],
      },
    ],
  },

  // ──────────────────────────────────────────────────────
  // INDICATOR 7
  // ──────────────────────────────────────────────────────
  {
    id: CA100_disclosureMetrics.Indicator_7,
    progress: CA100_disclosureMetrics.Indicator_7_Progress,
    children: [
      {
        id: CA100_disclosureMetrics.Indicator_7_1,
        progress: CA100_disclosureMetrics.Indicator_7_1_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_7_1_a,
            progress: CA100_disclosureMetrics.Metric_7_1_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_7_1_b,
            progress: CA100_disclosureMetrics.Metric_7_1_b_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_7_1_c,
            progress: CA100_disclosureMetrics.Metric_7_1_c_Progress,
          },
        ],
      },
      {
        id: CA100_disclosureMetrics.Indicator_7_2,
        progress: CA100_disclosureMetrics.Indicator_7_2_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_7_2_a,
            progress: CA100_disclosureMetrics.Metric_7_2_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_7_2_b,
            progress: CA100_disclosureMetrics.Metric_7_2_b_Progress,
          },
        ],
      },
    ],
  },

  // ──────────────────────────────────────────────────────
  // INDICATOR 8
  // ──────────────────────────────────────────────────────
  {
    id: CA100_disclosureMetrics.Indicator_8,
    progress: CA100_disclosureMetrics.Indicator_8_Progress,
    children: [
      {
        id: CA100_disclosureMetrics.Indicator_8_1,
        progress: CA100_disclosureMetrics.Indicator_8_1_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_8_1_a,
            progress: CA100_disclosureMetrics.Metric_8_1_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_8_1_b,
            progress: CA100_disclosureMetrics.Metric_8_1_b_Progress,
          },
        ],
      },
      {
        id: CA100_disclosureMetrics.Indicator_8_2,
        progress: CA100_disclosureMetrics.Indicator_8_2_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_8_2_a,
            progress: CA100_disclosureMetrics.Metric_8_2_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_8_2_b,
            progress: CA100_disclosureMetrics.Metric_8_2_b_Progress,
          },
        ],
      },
      {
        id: CA100_disclosureMetrics.Indicator_8_3,
        progress: CA100_disclosureMetrics.Indicator_8_3_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_8_3_a,
            progress: CA100_disclosureMetrics.Metric_8_3_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_8_3_b,
            progress: CA100_disclosureMetrics.Metric_8_3_b_Progress,
          },
        ],
      },
    ],
  },

  // ──────────────────────────────────────────────────────
  // INDICATOR 9
  // ──────────────────────────────────────────────────────
  {
    id: CA100_disclosureMetrics.Indicator_9,
    progress: CA100_disclosureMetrics.Indicator_9_Progress,
    children: [
      {
        id: CA100_disclosureMetrics.Indicator_9_1,
        progress: CA100_disclosureMetrics.Indicator_9_1_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_9_1_a,
            progress: CA100_disclosureMetrics.Metric_9_1_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_9_1_b,
            progress: CA100_disclosureMetrics.Metric_9_1_b_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_9_1_c,
            progress: CA100_disclosureMetrics.Metric_9_1_c_Progress,
          },
        ],
      },
      {
        id: CA100_disclosureMetrics.Indicator_9_2,
        progress: CA100_disclosureMetrics.Indicator_9_2_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_9_2_a,
            progress: CA100_disclosureMetrics.Metric_9_2_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_9_2_b,
            progress: CA100_disclosureMetrics.Metric_9_2_b_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_9_2_c,
            progress: CA100_disclosureMetrics.Metric_9_2_c_Progress,
          },
        ],
      },
    ],
  },

  // ──────────────────────────────────────────────────────
  // INDICATOR 10
  // ──────────────────────────────────────────────────────
  {
    id: CA100_disclosureMetrics.Indicator_10,
    progress: CA100_disclosureMetrics.Indicator_10_Progress,
    children: [
      {
        id: CA100_disclosureMetrics.Indicator_10_1,
        progress: CA100_disclosureMetrics.Indicator_10_1_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_10_1_a,
            progress: CA100_disclosureMetrics.Metric_10_1_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_10_1_b,
            progress: CA100_disclosureMetrics.Metric_10_1_b_Progress,
          },
        ],
      },
      {
        id: CA100_disclosureMetrics.Indicator_10_2,
        progress: CA100_disclosureMetrics.Indicator_10_2_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_10_2_a,
            progress: CA100_disclosureMetrics.Metric_10_2_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_10_2_b,
            progress: CA100_disclosureMetrics.Metric_10_2_b_Progress,
          },
        ],
      },
    ],
  },

  // ──────────────────────────────────────────────────────
  // INDICATOR 11
  // ──────────────────────────────────────────────────────
  {
    id: CA100_disclosureMetrics.Indicator_11,
    progress: CA100_disclosureMetrics.Indicator_11_Progress,
    children: [
      {
        id: CA100_disclosureMetrics.Indicator_11_1,
        progress: CA100_disclosureMetrics.Indicator_11_1_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_11_1_a,
            progress: CA100_disclosureMetrics.Metric_11_1_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_11_1_b,
            progress: CA100_disclosureMetrics.Metric_11_1_b_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_11_1_c,
            progress: CA100_disclosureMetrics.Metric_11_1_c_Progress,
          },
        ],
      },
      {
        id: CA100_disclosureMetrics.Indicator_11_2,
        progress: CA100_disclosureMetrics.Indicator_11_2_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_11_2_a,
            progress: CA100_disclosureMetrics.Metric_11_2_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_11_2_b,
            progress: CA100_disclosureMetrics.Metric_11_2_b_Progress,
          },
        ],
      },
      {
        id: CA100_disclosureMetrics.Indicator_11_3,
        progress: CA100_disclosureMetrics.Indicator_11_3_Progress,
        children: [
          {
            id: CA100_disclosureMetrics.Metric_11_3_a,
            progress: CA100_disclosureMetrics.Metric_11_3_a_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_11_3_b,
            progress: CA100_disclosureMetrics.Metric_11_3_b_Progress,
          },
          {
            id: CA100_disclosureMetrics.Metric_11_3_c,
            progress: CA100_disclosureMetrics.Metric_11_3_c_Progress,
          },
        ],
      },
    ],
  },
];

// Each node in the tree can have an optional `children` array to nest deeper nodes.
export interface CA100LobbyingTreeNode {
  id: CA100_lobbyingMetrics;
  progress?: CA100_lobbyingMetrics;
  children?: CA100LobbyingTreeNode[];
}

// A top-level array of nodes (Indicators). Each node can have children (sub‐Indicators).
export const CA100_LOBBYING_TREE: CA100LobbyingTreeNode[] = [
  // ─────────────────────────────────────────────────────────────────
  // INDICATOR 1 (Has sub‐indicators: Indicator_1_1 and Indicator_1_2)
  // ─────────────────────────────────────────────────────────────────
  {
    id: CA100_lobbyingMetrics.Indicator_1,
    progress: CA100_lobbyingMetrics.Indicator_1_Progress,
    children: [
      {
        id: CA100_lobbyingMetrics.Indicator_1_1,
        progress: CA100_lobbyingMetrics.Indicator_1_1_Progress,
      },
      {
        id: CA100_lobbyingMetrics.Indicator_1_2,
        progress: CA100_lobbyingMetrics.Indicator_1_2_Progress,
      },
    ],
  },

  // ─────────────────────────────────────────────────────────────────
  // INDICATOR 2 (Has sub‐indicators: Indicator_2_1 and Indicator_2_2)
  // ─────────────────────────────────────────────────────────────────
  {
    id: CA100_lobbyingMetrics.Indicator_2,
    progress: CA100_lobbyingMetrics.Indicator_2_Progress,
    children: [
      {
        id: CA100_lobbyingMetrics.Indicator_2_1,
        progress: CA100_lobbyingMetrics.Indicator_2_1_Progress,
      },
      {
        id: CA100_lobbyingMetrics.Indicator_2_2,
        progress: CA100_lobbyingMetrics.Indicator_2_2_Progress,
      },
    ],
  },

  // ─────────────────────────────────────────────────────────────────
  // INDICATOR 3 (No sub‐indicators defined, so no children needed)
  // ─────────────────────────────────────────────────────────────────
  {
    id: CA100_lobbyingMetrics.Indicator_3,
    progress: CA100_lobbyingMetrics.Indicator_3_Progress,
  },
];

export enum Ca100DisclosureIndicatorValue {
  N = "N",
  Y = "Y",
  P = "Partial",
  NA = "-",
  NotApplicable = "Not Applicable",
}

export const CA100_DISCLOSURE_VALUE_MAP: Record<
  Ca100DisclosureIndicatorValue,
  string
> = {
  [Ca100DisclosureIndicatorValue.N]: failCircle,
  [Ca100DisclosureIndicatorValue.Y]: successCircle,
  [Ca100DisclosureIndicatorValue.P]: partialCircle,
  [Ca100DisclosureIndicatorValue.NA]: naCircle,
  [Ca100DisclosureIndicatorValue.NotApplicable]: naCircle,
};

export const CA100_DISCLOSURE_VALUE_MAP_TOP_LEVEL: Record<
  Ca100DisclosureIndicatorValue,
  string
> = {
  [Ca100DisclosureIndicatorValue.N]: redCheckbox,
  [Ca100DisclosureIndicatorValue.Y]: greenCheckbox,
  [Ca100DisclosureIndicatorValue.P]: partialCheckbox,
  [Ca100DisclosureIndicatorValue.NA]: naCheckbox,
  [Ca100DisclosureIndicatorValue.NotApplicable]: naCheckbox,
};

export enum AlignmentGrade {
  Aligned = "Yes, meets criteria",
  PartiallyAligned = "Partial, meets some criteria",
  CriteriaNotMet = "No, does not meet criteria",
  AlignedAPlus = "Aligned - A+",
  AlignedA = "Aligned - A",
  AlignedAMinus = "Aligned - A-",
  AlignedBPlus = "Aligned - B+",
  AlignedB = "Aligned - B",
  AlignedBMinus = "Aligned - B-",
  AlignedCPlus = "Aligned - C+",
  AlignedC = "Aligned - C",
  AlignedCMinus = "Aligned - C-",
  AlignedDPlus = "Aligned - D+",
  AlignedD = "Aligned - D",
  AlignedDMinus = "Aligned - D-",
  AlignedEPlus = "Aligned - E+",
  AlignedE = "Aligned - E",
  AlignedEMinus = "Aligned - E-",
  AlignedF = "Aligned - F",

  PartiallyAlignedAPlus = "Partially aligned - A+",
  PartiallyAlignedA = "Partially aligned - A",
  PartiallyAlignedAMinus = "Partially aligned - A-",
  PartiallyAlignedBPlus = "Partially aligned - B+",
  PartiallyAlignedB = "Partially aligned - B",
  PartiallyAlignedBMinus = "Partially aligned - B-",
  PartiallyAlignedCPlus = "Partially aligned - C+",
  PartiallyAlignedC = "Partially aligned - C",
  PartiallyAlignedCMinus = "Partially aligned - C-",
  PartiallyAlignedDPlus = "Partially aligned - D+",
  PartiallyAlignedD = "Partially aligned - D",
  PartiallyAlignedDMinus = "Partially aligned - D-",
  PartiallyAlignedEPlus = "Partially aligned - E+",
  PartiallyAlignedE = "Partially aligned - E",
  PartiallyAlignedEMinus = "Partially aligned - E-",
  PartiallyAlignedF = "Partially aligned - F",

  MisalignedAPlus = "Misaligned - A+",
  MisalignedA = "Misaligned - A",
  MisalignedAMinus = "Misaligned - A-",
  MisalignedBPlus = "Misaligned - B+",
  MisalignedB = "Misaligned - B",
  MisalignedBMinus = "Misaligned - B-",
  MisalignedCPlus = "Misaligned - C+",
  MisalignedC = "Misaligned - C",
  MisalignedCMinus = "Misaligned - C-",
  MisalignedDPlus = "Misaligned - D+",
  MisalignedD = "Misaligned - D",
  MisalignedDMinus = "Misaligned - D-",
  MisalignedEPlus = "Misaligned - E+",
  MisalignedE = "Misaligned - E",
  MisalignedEMinus = "Misaligned - E-",
  MisalignedF = "Misaligned - F",
}

export const AlignmentGradeScoreMap: Record<AlignmentGrade, number> = {
  [AlignmentGrade.CriteriaNotMet]: 1,
  [AlignmentGrade.Aligned]: 100,
  [AlignmentGrade.PartiallyAligned]: 50,
  [AlignmentGrade.AlignedAPlus]: 100,
  [AlignmentGrade.AlignedA]: 95,
  [AlignmentGrade.AlignedAMinus]: 90,
  [AlignmentGrade.AlignedBPlus]: 85,
  [AlignmentGrade.AlignedB]: 80,
  [AlignmentGrade.AlignedBMinus]: 75,
  [AlignmentGrade.AlignedCPlus]: 70,
  [AlignmentGrade.AlignedC]: 65,
  [AlignmentGrade.AlignedCMinus]: 60,
  [AlignmentGrade.AlignedDPlus]: 55,
  [AlignmentGrade.AlignedD]: 50,
  [AlignmentGrade.AlignedDMinus]: 45,
  [AlignmentGrade.AlignedEPlus]: 40,
  [AlignmentGrade.AlignedE]: 35,
  [AlignmentGrade.AlignedEMinus]: 30,
  [AlignmentGrade.AlignedF]: 20,

  [AlignmentGrade.PartiallyAlignedAPlus]: 100,
  [AlignmentGrade.PartiallyAlignedA]: 95,
  [AlignmentGrade.PartiallyAlignedAMinus]: 90,
  [AlignmentGrade.PartiallyAlignedBPlus]: 85,
  [AlignmentGrade.PartiallyAlignedB]: 80,
  [AlignmentGrade.PartiallyAlignedBMinus]: 75,
  [AlignmentGrade.PartiallyAlignedCPlus]: 70,
  [AlignmentGrade.PartiallyAlignedC]: 65,
  [AlignmentGrade.PartiallyAlignedCMinus]: 60,
  [AlignmentGrade.PartiallyAlignedDPlus]: 55,
  [AlignmentGrade.PartiallyAlignedD]: 50,
  [AlignmentGrade.PartiallyAlignedDMinus]: 45,
  [AlignmentGrade.PartiallyAlignedEPlus]: 40,
  [AlignmentGrade.PartiallyAlignedE]: 35,
  [AlignmentGrade.PartiallyAlignedEMinus]: 30,
  [AlignmentGrade.PartiallyAlignedF]: 20,

  [AlignmentGrade.MisalignedAPlus]: 100,
  [AlignmentGrade.MisalignedA]: 95,
  [AlignmentGrade.MisalignedAMinus]: 90,
  [AlignmentGrade.MisalignedBPlus]: 85,
  [AlignmentGrade.MisalignedB]: 80,
  [AlignmentGrade.MisalignedBMinus]: 75,
  [AlignmentGrade.MisalignedCPlus]: 70,
  [AlignmentGrade.MisalignedC]: 65,
  [AlignmentGrade.MisalignedCMinus]: 60,
  [AlignmentGrade.MisalignedDPlus]: 55,
  [AlignmentGrade.MisalignedD]: 50,
  [AlignmentGrade.MisalignedDMinus]: 45,
  [AlignmentGrade.MisalignedEPlus]: 40,
  [AlignmentGrade.MisalignedE]: 35,
  [AlignmentGrade.MisalignedEMinus]: 30,
  [AlignmentGrade.MisalignedF]: 20,
};

export const LOBBYING_BARS_METRIC_IDS: CA100_lobbyingMetrics[] = [
  CA100_lobbyingMetrics.Indicator_1,
  CA100_lobbyingMetrics.Indicator_2,
  CA100_lobbyingMetrics.Indicator_3,
];

export const PERCENTAGE_TO_BADGE_COLORS_MAPPING = {
  na: {
    bg: statusBadgeColors.Planned.bg,
    text: statusBadgeColors.Planned.text,
  },
  low: {
    bg: statusBadgeColors.Stuck.bg,
    text: statusBadgeColors.Stuck.text,
  },
  mid: {
    bg: statusBadgeColors.Warning.bg,
    text: statusBadgeColors.Warning.text,
  },
  high: {
    bg: statusBadgeColors.Complete.bg,
    text: statusBadgeColors.Complete.text,
  },
};

export const LOBBYING_CHILD_NODE_REGEX = /Individual % score (\d+(?:\.\d+)?)/;
export const LOBBYING_BASE_REGEX = /\((\d+(?:\.\d+)?)%\)/;
